export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessMangement11.2ad8ef4b.png";